import { Component, OnChanges, OnInit, AfterViewInit, SimpleChange, Input, Output, EventEmitter, HostListener, ChangeDetectionStrategy } from '@angular/core';
import { TreeData, TreeNode, TreeOptions } from './tree.interface';
import * as _ from 'lodash';
import { NavigationStart, Router } from '@angular/router';
import { trigger, transition, style, animate } from '@angular/animations';
import { BrowserDetectorService } from 'src/app/services/browser-detector.service';
import { fadeInOutWithBlur } from '../global-app-animations';

@Component({
    selector: 'app-tree',
    templateUrl: './tree.component.html',
    styleUrls: ['./tree.component.scss'],
    animations: [
        fadeInOutWithBlur
    ],
    standalone: false
})
export class TreeComponent implements OnInit, OnChanges, AfterViewInit {

  @Input() data: TreeNode[] = [];

  @Input() expanded: boolean = false;

  //outputs 
  @Output() onNodeClick: EventEmitter<any> = new EventEmitter<any>();


  //field: Object;

  parsedOptions: TreeOptions | undefined;
  parsedData: TreeData | undefined;
  mobile: boolean = false;

  readyToGo: boolean = false;

  constructor(
    private router: Router, private browserDetector: BrowserDetectorService) {
    this.mobile = this.browserDetector.detectBrowserMobile()
    //this.field = { dataSource: this.data, id: 'id', text: 'name', child: 'children' };
  }

  ngOnInit(): void {
    this.nodeOperation(this.router.url);

    setTimeout(() => {
      this.readyToGo = true;
      console.log('ready', this.readyToGo)
    }, 600);
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.mobile = this.browserDetector.detectBrowserMobile()
  }

  nodeOperation(url: string) {
    this.data?.forEach(node => {
      let route = '/' + node.route;

      node.cssClass = ''


      if (url.includes(route)) {
        node.expand = true;
        node.cssClass = 'node-selected'
      }

      node.children.forEach(nodeCh => {
        // let routeCh = '/'+nodeCh.route;
        // nodeCh.expand = false;
        // nodeCh.cssClass = ''
        // let routeSplit = routeCh.split('/');
        // let lastOne = '';
        // routeSplit.forEach(rs=>{
        //   lastOne = rs;
        // })
        //   if(url.includes(routeCh) || url.includes(lastOne)){

        //   nodeCh.cssClass = 'node-selected'
        //   node.expand = true;
        // }
        this.nodeRepeat(nodeCh, url)

      })

      if (node.expand) {
        node.iconClass = 'e-chevron-down'
      } else {
        node.iconClass = 'e-chevron-right'
      }
    })
  }


  nodeRepeat(nodeCh: TreeNode, url: string) {

    let routeCh = '/' + nodeCh.route;
    nodeCh.expand = false;
    nodeCh.cssClass = ''
    let routeSplit = routeCh.split('/');
    let lastOne = '';
    routeSplit.forEach(rs => {
      lastOne = rs;
    })
    if (url.includes(routeCh) || url.includes(lastOne)) {

      nodeCh.cssClass = 'node-selected'
      if (this.data) {
        this.data[nodeCh.childOf].expand = true;
      }

    }

    if (nodeCh.children.length > 0) {
      nodeCh.children.forEach(nodeChCh => {
        this.nodeRepeat(nodeChCh, url)
      })
    }


  }

  // expandNode(name:string){
  //   let index:number = this.data?.findIndex(x=> x.name == name) || 0;
  //   this.data![index].expand = !this.data![index||0].expand 
  //   if(this.data![index].iconClass == 'e-chevron-right'){
  //     this.data![index].iconClass = 'e-chevron-down'
  //   }else{
  //     this.data![index].iconClass ='e-chevron-right';
  //   }
  // }

  ngAfterViewInit(): void {
  
  }

  ngOnChanges(changes: { options: SimpleChange, data: SimpleChange }): void {
    if (changes.options) this.parseOptiopns(changes.options.currentValue)
    if (changes.data) this.parseData(changes.data.currentValue);
  }

  //#region private methods

  private parseOptiopns(options: TreeOptions) {
    this.parsedOptions = _.cloneDeep(options)

  }

  private parseData(data: TreeData) {
    this.parsedData = _.cloneDeep(data)
  }

  nodeClick(event: any) {
    this.onNodeClick.emit(event);
  }
  //#endregion

  // onNodeSelect(event: any) {
  //   //console.log(event.nodeData);
  //   //let data:any = this.tree!.getTreeData(event.node.id);    
  //   //let seriusData:any = this.tree!.getTreeData().find(x => x['id'] == event.nodeData.id || x['text'] == event.nodeData.text);  
  //   //console.log(seriusData[0]['route']);
  //   this.router.navigate([event]); 
  //   //this.onNodeClick.emit(event);
  // }

  // newWindow(event: any) {
  //   //console.log(event.nodeData);
  //   //let data:any = this.tree!.getTreeData(event.node.id);    
  //   //let seriusData:any = this.tree!.getTreeData().find(x => x['id'] == event.nodeData.id || x['text'] == event.nodeData.text);  
  //   //console.log(seriusData[0]['route']);
  //   // this.router.navigate([event]); 
  //   window.open(event, '_blank')
  //   //this.onNodeClick.emit(event);
  // }

}
